const blockedParamNames = ['email', 'phone', 'name', 'address', 'description', 'message', 'file', 'photo'];
const allowedLocationParamNames = ['phone_location', 'email_location'];

const safeValue = (value) => {
  if (value === undefined || value === null) return undefined;
  if (typeof value === 'boolean' || typeof value === 'number') return value;
  return String(value).slice(0, 100);
};

const sanitizeParams = (params = {}) => Object.entries(params).reduce((safeParams, [key, value]) => {
  const keyLower = key.toLowerCase();
  if (!allowedLocationParamNames.includes(keyLower) && blockedParamNames.some((blocked) => keyLower.includes(blocked))) return safeParams;
  const sanitizedValue = safeValue(value);
  if (sanitizedValue !== undefined) safeParams[key] = sanitizedValue;
  return safeParams;
}, {});

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;

  window.gtag('event', eventName, {
    ...sanitizeParams(params),
    page_path: window.location.pathname
  });
};

export const trackEventOnce = (onceKey, eventName, params = {}) => {
  if (typeof window === 'undefined') return;
  window.__ga4EventOnceKeys = window.__ga4EventOnceKeys || new Set();
  const scopedKey = `${window.location.pathname}:${onceKey}`;
  if (window.__ga4EventOnceKeys.has(scopedKey)) return;
  window.__ga4EventOnceKeys.add(scopedKey);
  trackEvent(eventName, params);
};